<script setup lang="ts">
interface TabItem {
  key: string;
  label: string;
}

defineProps<{
  tabs: TabItem[];
  modelValue: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [key: string];
}>();

function select(key: string) {
  emit('update:modelValue', key);
}
</script>

<template>
  <div class="pet__tabbar" role="tablist">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="pet__tab"
      :class="{ 'pet__tab--active': tab.key === modelValue }"
      :aria-selected="tab.key === modelValue"
      @click="select(tab.key)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<style scoped>
.pet__tabbar {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  border-bottom: 1px solid var(--nxt-outline-variant);
  scrollbar-width: thin;
}
.pet__tabbar::-webkit-scrollbar {
  height: 4px;
}
.pet__tabbar::-webkit-scrollbar-thumb {
  background: var(--nxt-outline-variant);
  border-radius: 0.25rem;
}

.pet__tab {
  flex-shrink: 0;
  appearance: none;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--nxt-on-surface-muted);
  cursor: pointer;
  transition:
    color 0.15s ease,
    border-color 0.15s ease;
}
.pet__tab:hover {
  color: var(--nxt-on-surface);
}
.pet__tab--active {
  color: var(--nxt-primary);
  border-bottom-color: var(--nxt-primary);
  font-weight: 700;
}

[data-theme='dark'] .pet__tab--active {
  color: #ffd60a;
  border-bottom-color: #ffd60a;
}
</style>
